import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signUp } from '../../api';
import type { SignUpParams } from '../../types';
import { identifyDataLayerUser } from '@/shared/analytics';

export function useSignUp() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: SignUpParams) => signUp(params),
    onSuccess: (user) => {
      identifyDataLayerUser(user.id);
      return queryClient.invalidateQueries({ queryKey: ['me'] });
    },
  });
}
